import useAddScripts from '@/utils/dom/useAddScripts'

import './css/styles.scss'
import './css/referralStyles.scss'
import { Helmet } from 'react-helmet'
import { Box, Typography } from '@material-ui/core'
import ReferralCard from '@/unauthenticated/components/v2/ReferralCard'
import UtilityProgramReferralLearnMoreCard from '@/app/features/utility-programs/UtilityProgramReferralLearnMoreCard'
import formatClasses from '@/utils/classes/formatClasses'

import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import { StylesProvider } from '@material-ui/styles'
import { ThemeProvider } from 'styled-components'
import maTheme from '../../../../v2/theme'
import { optiwattConsts } from '@/optiwattConsts'

type Props = {
  beeActive: boolean
  utilityProgramReferralActive: boolean
  dismissReferral: () => void
  signUpPath: string
}

function Header() {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <meta httpEquiv="x-ua-compatible" content="ie=edge" />
      <title>Optiwatt</title>
      <meta name="description" content="" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.min.css"
        integrity="sha512-NhSC1YmyruXifcj/KFRWoC561YpHpc5Jtzgvbuzx5VozKpWvQ+4nXhPdFgmx8xqexRcpAglTj9sIBWINXa8x5w=="
        crossOrigin="anonymous"
        referrerPolicy="no-referrer"
      />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,500;0,600;0,700;0,800;1,500&display=swap"
        integrity="sha384-Oila0e/S3rJbkAK+7peo/hajiaDdVaDMtEPqi1G6uje0507Nkxs9GPv2xljb0pfb"
        crossOrigin="anonymous"
      />
    </Helmet>
  )
}

function ReferralSection({
  beeActive,
  utilityProgramReferralActive,
  dismissReferral,
}: Props) {
  const classes = {
    beeReferralContainer: formatClasses(['bee-referral-container']),
  }

  return (
    <div
      style={{
        position: 'relative',
        zIndex: 100000,
        padding: 0,
        maxWidth: '1180px',
        margin: 'auto',
      }}
    >
      {beeActive && (
        <Box className={classes.beeReferralContainer}>
          <ReferralCard
            title="WE NEED BEES!"
            buttonText="Sign Up & Save The Bees"
            imgSource="img/pollinators.webp"
            subtitleComponent={
              <Typography variant="body1">
                90% of plant species need pollinators, like bees to reproduce.
                But bees are at risk of going extinct. So we're{' '}
                <Box component="span" fontWeight="fontWeightBold">
                  donating $10 for every sign up.
                </Box>
              </Typography>
            }
            onClose={dismissReferral}
          />
        </Box>
      )}
      {utilityProgramReferralActive && (
        <UtilityProgramReferralLearnMoreCard onClose={dismissReferral} />
      )}
    </div>
  )
}

function VehicleLandingComponent(props: Props) {
  useAddScripts([
    'https://cdnjs.cloudflare.com/ajax/libs/axios/1.2.2/axios.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/animejs/3.2.1/anime.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/waypoints/4.0.1/noframework.waypoints.min.js',
    'landing-assets/vehicle/js/script.js',
  ])

  const referralActive = props.beeActive || props.utilityProgramReferralActive

  return (
    <div className="vehicle-landing-scope">
      <Header />
      <div className="page">
        <div className="main-content">
          <div className="decor decor-0">
            <div className="decor-wrapper">
              <svg
                width="948"
                height="674"
                viewBox="0 0 948 674"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.999817 0.999999L-0.5 566C448.03 851.558 1045.56 537.057 934.395 0.5L0.999817 0.999999Z"
                  fill="#F3F6FF"
                />
              </svg>
            </div>
          </div>
          <header className="header">
            <div className="section-content">
              <div className="group group-0">
                <div className="item item-0 item-media">
                  <div className="photo-container">
                    <div style={{ paddingTop: '18.5%' }}></div>
                    <a className="photo-holder" href="/">
                      <img
                        src="landing-assets/vehicle/img/logoDark.webp"
                        loading="lazy"
                      />
                    </a>
                  </div>
                </div>
              </div>
              <div className="group group-1">
                <div className="item item-0 item-list nav">
                  <ul className="list">
                    <li>
                      <a href="/news" target="_blank">
                        <div className="group group-0">
                          <div className="item item-0 item-text">
                            <p className="text-content">News</p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://optiwatt.applytojob.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className="group group-0">
                          <div className="item item-0 item-text">
                            <p className="text-content">Careers</p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="/faq" target="_blank">
                        <div className="group group-0">
                          <div className="item item-0 item-text">
                            <p className="text-content">FAQ</p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="/partners" target="_blank">
                        <div className="group group-0">
                          <div className="item item-0 item-text">
                            <p className="text-content">Partners</p>
                          </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="group group-2">
                <div className="item item-0 item-text">
                  <p className="text-content">
                    <a href="/login">Login</a>
                  </p>
                </div>
                <div className="item item-1 item-button button-style-primary">
                  <a href={props.signUpPath}>
                    <button className="button">Sign Up</button>
                  </a>
                </div>
              </div>
              <div className="group group-3">
                <div className="item item-0 item-button mobile-nav-btn">
                  <button className="button">
                    <span>Menu</span>
                    <div className="svg-content">
                      <div className="icon icon-hamburger">
                        <svg
                          width="16"
                          height="18"
                          viewBox="0 0 16 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.8002 7.6001L3.2002 7.6001"
                            stroke="#424F76"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M12.8002 12.3999L3.2002 12.3999"
                            stroke="#424F76"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="icon icon-x">
                        <svg
                          width="16"
                          height="18"
                          viewBox="0 0 16 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.3941 13.3942L4.60583 6.60596"
                            stroke="#424F76"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M11.3943 6.60582L4.60608 13.394"
                            stroke="#424F76"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
              <div className="group group-4">
                <div className="item item-0 item-list mobile-nav-links">
                  <ul className="list">
                    <li>
                      <a href="/news" target="_blank">
                        <div className="group group-0">
                          <div className="item item-0 item-text">
                            <p className="text-content">News</p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://optiwatt.applytojob.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className="group group-0">
                          <div className="item item-0 item-text">
                            <p className="text-content">Careers</p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="/faq" target="_blank">
                        <div className="group group-0">
                          <div className="item item-0 item-text">
                            <p className="text-content">FAQ</p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="/partners" target="_blank">
                        <div className="group group-0">
                          <div className="item item-0 item-text">
                            <p className="text-content">Partners</p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="login-link">
                      <a href="/login">
                        <div className="group group-0">
                          <div className="item item-0 item-text">
                            <p className="text-content">
                              <span>Login</span>
                              <svg
                                width="16"
                                height="18"
                                viewBox="0 0 16 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.59998 6L10.4 10L5.59998 14"
                                  stroke="#871BF2"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <div className="group group-0">
                        <div className="item item-1 item-button button-style-primary">
                          <a href={props.signUpPath}>
                            <button className="button">Sign Up</button>
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </header>
          <div className="sections">
            {referralActive && (
              <section className="section referral">
                <ReferralSection {...props} />
              </section>
            )}

            <section className="section hero">
              <div className="section-content">
                <div className="group group-0">
                  <div className="item item-text item-0 title">
                    <h1 className="text-content">
                      EV Scheduler.
                      <br />
                      <span className="text-gradient">Enhanced.</span>
                    </h1>
                  </div>
                  <div className="item item-text item-1 body">
                    <p className="text-content">
                      Unlock even more savings than with your current EV
                      scheduler app.
                    </p>
                  </div>
                  <div className="item item-list item-2 buttons">
                    <ul className="list">
                      <li>
                        <div className="group group-0">
                          <div className="item item-button item-0 has-link button-style-primary">
                            <a href={props.signUpPath}>
                              <button className="button">Get Started</button>
                            </a>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="group group-0">
                          <div className="item item-button item-0 has-link button-style-alternate">
                            <a href="download">
                              <button className="button">
                                Get the App
                                <svg
                                  width="8"
                                  height="10"
                                  viewBox="0 0 8 10"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M1.6001 1L6.4001 5L1.6001 9"
                                    stroke="#871BF2"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </button>
                            </a>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="item item-list item-3 stats">
                    <ul className="list">
                      <li>
                        <div className="group group-0">
                          <div className="item item-text item-0 big">
                            <p className="text-content">3k</p>
                          </div>
                          <div className="item item-text item-1 label">
                            <p className="text-content">Ratings</p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="group group-0">
                          <div className="item item-text item-0 big">
                            <p className="text-content">4.8</p>
                          </div>
                          <div className="item item-text item-1 label">
                            <p className="text-content">
                              <svg
                                width="88"
                                height="20"
                                viewBox="0 0 88 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9.04894 2.92705C9.3483 2.00574 10.6517 2.00574 10.9511 2.92705L12.0206 6.21885C12.1545 6.63087 12.5385 6.90983 12.9717 6.90983H16.4329C17.4016 6.90983 17.8044 8.14945 17.0207 8.71885L14.2205 10.7533C13.87 11.0079 13.7234 11.4593 13.8572 11.8713L14.9268 15.1631C15.2261 16.0844 14.1717 16.8506 13.388 16.2812L10.5878 14.2467C10.2373 13.9921 9.7627 13.9921 9.41221 14.2467L6.61204 16.2812C5.82833 16.8506 4.77385 16.0844 5.0732 15.1631L6.14277 11.8713C6.27665 11.4593 6.12999 11.0079 5.7795 10.7533L2.97933 8.71885C2.19562 8.14945 2.59839 6.90983 3.56712 6.90983H7.02832C7.46154 6.90983 7.8455 6.63087 7.97937 6.21885L9.04894 2.92705Z"
                                  fill="#F9BE27"
                                />
                                <path
                                  d="M26.0489 2.92705C26.3483 2.00574 27.6517 2.00574 27.9511 2.92705L29.0206 6.21885C29.1545 6.63087 29.5385 6.90983 29.9717 6.90983H33.4329C34.4016 6.90983 34.8044 8.14945 34.0207 8.71885L31.2205 10.7533C30.87 11.0079 30.7234 11.4593 30.8572 11.8713L31.9268 15.1631C32.2261 16.0844 31.1717 16.8506 30.388 16.2812L27.5878 14.2467C27.2373 13.9921 26.7627 13.9921 26.4122 14.2467L23.612 16.2812C22.8283 16.8506 21.7739 16.0844 22.0732 15.1631L23.1428 11.8713C23.2766 11.4593 23.13 11.0079 22.7795 10.7533L19.9793 8.71885C19.1956 8.14945 19.5984 6.90983 20.5671 6.90983H24.0283C24.4615 6.90983 24.8455 6.63087 24.9794 6.21885L26.0489 2.92705Z"
                                  fill="#F9BE27"
                                />
                                <path
                                  d="M43.0489 2.92705C43.3483 2.00574 44.6517 2.00574 44.9511 2.92705L46.0206 6.21885C46.1545 6.63087 46.5385 6.90983 46.9717 6.90983H50.4329C51.4016 6.90983 51.8044 8.14945 51.0207 8.71885L48.2205 10.7533C47.87 11.0079 47.7234 11.4593 47.8572 11.8713L48.9268 15.1631C49.2261 16.0844 48.1717 16.8506 47.388 16.2812L44.5878 14.2467C44.2373 13.9921 43.7627 13.9921 43.4122 14.2467L40.612 16.2812C39.8283 16.8506 38.7739 16.0844 39.0732 15.1631L40.1428 11.8713C40.2766 11.4593 40.13 11.0079 39.7795 10.7533L36.9793 8.71885C36.1956 8.14945 36.5984 6.90983 37.5671 6.90983H41.0283C41.4615 6.90983 41.8455 6.63087 41.9794 6.21885L43.0489 2.92705Z"
                                  fill="#F9BE27"
                                />
                                <path
                                  d="M60.0489 2.92705C60.3483 2.00574 61.6517 2.00574 61.9511 2.92705L63.0206 6.21885C63.1545 6.63087 63.5385 6.90983 63.9717 6.90983H67.4329C68.4016 6.90983 68.8044 8.14945 68.0207 8.71885L65.2205 10.7533C64.87 11.0079 64.7234 11.4593 64.8572 11.8713L65.9268 15.1631C66.2261 16.0844 65.1717 16.8506 64.388 16.2812L61.5878 14.2467C61.2373 13.9921 60.7627 13.9921 60.4122 14.2467L57.612 16.2812C56.8283 16.8506 55.7739 16.0844 56.0732 15.1631L57.1428 11.8713C57.2766 11.4593 57.13 11.0079 56.7795 10.7533L53.9793 8.71885C53.1956 8.14945 53.5984 6.90983 54.5671 6.90983H58.0283C58.4615 6.90983 58.8455 6.63087 58.9794 6.21885L60.0489 2.92705Z"
                                  fill="#F9BE27"
                                />
                                <path
                                  d="M77.0489 2.92705C77.3483 2.00574 78.6517 2.00574 78.9511 2.92705L80.0206 6.21885C80.1545 6.63087 80.5385 6.90983 80.9717 6.90983H84.4329C85.4016 6.90983 85.8044 8.14945 85.0207 8.71885L82.2205 10.7533C81.87 11.0079 81.7234 11.4593 81.8572 11.8713L82.9268 15.1631C83.2261 16.0844 82.1717 16.8506 81.388 16.2812L78.5878 14.2467C78.2373 13.9921 77.7627 13.9921 77.4122 14.2467L74.612 16.2812C73.8283 16.8506 72.7739 16.0844 73.0732 15.1631L74.1428 11.8713C74.2766 11.4593 74.13 11.0079 73.7795 10.7533L70.9793 8.71885C70.1956 8.14945 70.5984 6.90983 71.5671 6.90983H75.0283C75.4615 6.90983 75.8455 6.63087 75.9794 6.21885L77.0489 2.92705Z"
                                  fill="#F9BE27"
                                />
                              </svg>
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="group group-0">
                          <div className="item item-text item-0 big">
                            <p className="text-content">150k</p>
                          </div>
                          <div className="item item-text item-1 label">
                            <p className="text-content">Downloads</p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="item item-4 item-subgroup testimonials">
                    <div className="group group-0">
                      <div className="item item-list item-0 quotes">
                        <ul className="list">
                          <li>
                            <div className="group group-0">
                              <p className="item item-text item-0">
                                “Been using the app for nearly a month now and
                                it honestly left me speechless!!! I never write
                                reviews for apps but this one was worth every
                                penny, but best part is that it's FREE. I
                                appreciate the frequent updates that come out to
                                improve the app! I love when companies really
                                work on the small details!”
                              </p>
                              <p className="item item-text item-1">Cade M.</p>
                            </div>
                          </li>
                          <li>
                            <div className="group group-0">
                              <p className="item item-text item-0">
                                “Exactly what I needed! I've been looking for an
                                app to track my home power usage since I live
                                with roommates and want to track my usage. There
                                are several other apps that do this but all
                                charge fees, this app does it wonderfully and
                                gives lots of other helpful information like the
                                electricity price based on your power bill, and
                                how much you've saved.”
                              </p>
                              <p className="item item-text item-1">Casey B.</p>
                            </div>
                          </li>
                          <li className="selected">
                            <div className="group group-0">
                              <p className="item item-text item-0">
                                “I have been using this app for about four
                                months now and it is pretty awesome. There is a
                                feature where you can allow the app to manage
                                charges, and additional options that you can
                                select that say the app will only allow when
                                your power grid is using clean electricity
                                and/or when electricity is at the cheapest rate.
                                I would recommend.”
                              </p>
                              <p className="item item-text item-1">NS Speed</p>
                            </div>
                          </li>
                          <li>
                            <div className="group group-0">
                              <p className="item item-text item-0">
                                “Great app, does what it is designed for and
                                does it for free. Easiest way to track what you
                                have spent. Customer support is next level.
                                Developers are responsive and did a great job
                                helping me correct my rates.”
                              </p>
                              <p className="item item-text item-1">Sean M.</p>
                            </div>
                          </li>
                          <li>
                            <div className="group group-0">
                              <p className="item item-text item-0">
                                “Easy sign up and set up, clean user interface,
                                nice stats on environmental impact and money
                                spent.”
                              </p>
                              <p className="item item-text item-1">Jordan C.</p>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div className="item item-list item-1 avatars">
                        <ul className="list">
                          <li>
                            <div className="group group-0">
                              <div className="item item-photo item-0">
                                <div className="photo-container">
                                  <div style={{ paddingTop: '100%' }}></div>
                                  <div className="photo-holder">
                                    <img src="landing-assets/vehicle/img/Eric1.webp" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="group group-0">
                              <div className="item item-photo item-0">
                                <div className="photo-container">
                                  <div style={{ paddingTop: '100%' }}></div>
                                  <div className="photo-holder">
                                    <img src="landing-assets/vehicle/img/Jasmine1.webp" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="group group-0">
                              <div className="item item-photo item-0">
                                <div className="photo-container">
                                  <div style={{ paddingTop: '100%' }}></div>
                                  <div className="photo-holder">
                                    <img src="landing-assets/vehicle/img/Emily1.webp" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="group group-0">
                              <div className="item item-photo item-0">
                                <div className="photo-container">
                                  <div style={{ paddingTop: '100%' }}></div>
                                  <div className="photo-holder">
                                    <img src="landing-assets/vehicle/img/Raul1.webp" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="group group-0">
                              <div className="item item-photo item-0">
                                <div className="photo-container">
                                  <div style={{ paddingTop: '100%' }}></div>
                                  <div className="photo-holder">
                                    <img src="landing-assets/vehicle/img/Jeniffer1.webp" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="group group-1 slides">
                  <div className="item item-0 item-list">
                    <ul className="list">
                      <li id="slide1">
                        <div className="group group-0">
                          <div className="item item-0 item-media">
                            <div className="photo-container">
                              <div className="photo-holder">
                                <img src="landing-assets/vehicle/img/slide1-static.webp" />
                              </div>
                            </div>
                          </div>
                          <div className="item item-1 item-media pa">
                            <div className="photo-container">
                              <div className="photo-holder">
                                <img src="landing-assets/vehicle/img/slide1-card1.webp" />
                              </div>
                            </div>
                          </div>
                          <div className="item item-2 item-media pa">
                            <div className="photo-container">
                              <div className="photo-holder">
                                <img src="landing-assets/vehicle/img/slide1-card2.webp" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li id="slide2">
                        <div className="group group-0">
                          <div className="item item-0 item-media">
                            <div className="photo-container">
                              <div className="photo-holder">
                                <img
                                  src="landing-assets/vehicle/img/slide2-static.webp"
                                  loading="lazy"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="item item-1 item-media pa">
                            <div className="photo-container">
                              <div className="photo-holder">
                                <img
                                  src="landing-assets/vehicle/img/slide2-card1.webp"
                                  loading="lazy"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="item item-2 item-media pa">
                            <div className="photo-container">
                              <div className="photo-holder">
                                <img
                                  src="landing-assets/vehicle/img/slide2-card2.webp"
                                  loading="lazy"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li id="slide3">
                        <div className="group group-0">
                          <div className="item item-0 item-media">
                            <div className="photo-container">
                              <div className="photo-holder">
                                <img
                                  src="landing-assets/vehicle/img/slide3-static.webp"
                                  loading="lazy"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="item item-1 item-media pa">
                            <div className="photo-container">
                              <div className="photo-holder">
                                <img
                                  src="landing-assets/vehicle/img/slide3-card1.webp"
                                  loading="lazy"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="item item-2 item-media pa">
                            <div className="photo-container">
                              <div className="photo-holder">
                                <img
                                  src="landing-assets/vehicle/img/slide3-card2.webp"
                                  loading="lazy"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
            <section className="section statement">
              <div className="bg-helper-container">
                <div
                  className="bg-helper"
                  style={{
                    backgroundImage:
                      "url('landing-assets/vehicle/img/background_image.webp')",
                  }}
                ></div>
              </div>
              <div className="section-content">
                <div className="group group-0">
                  <div className="item item-text item-0 title">
                    <p className="text-content">
                      Reduce your EV charging costs by up to
                    </p>
                  </div>
                </div>
                <div className="group group-1">
                  <div className="item item-text item-0 title">
                    <p className="text-content text-gradient">70%</p>
                  </div>
                  <div className="item item-text item-1 body">
                    <p className="text-content">
                      Optiwatt helps you save $388/year on average by
                      automatically scheduling your EV to charge when rates are
                      cheapest.
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section className="section logos">
              <div className="section-content">
                <div className="group group-0">
                  <div className="item item-0 item-media">
                    <div className="photo-container">
                      <div style={{ paddingTop: '28.0962491154%' }}></div>
                      <div className="photo-holder">
                        <img src="landing-assets/vehicle/img/ev-brands.webp" />
                      </div>
                    </div>
                  </div>
                  <div className="item item-1 item-media">
                    <div className="photo-container">
                      <div style={{ paddingTop: '28.0962491154%' }}></div>
                      <div className="photo-holder">
                        <img src="landing-assets/vehicle/img/ev-brands.webp" />
                      </div>
                    </div>
                  </div>
                  <div className="item item-2 item-media">
                    <div className="photo-container">
                      <div style={{ paddingTop: '28.0962491154%' }}></div>
                      <div className="photo-holder">
                        <img src="landing-assets/vehicle/img/ev-brands.webp" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="oh">
              <section className="section feature feature1">
                <div className="section-content">
                  <div className="group group-0 not-mobile">
                    <div className="item item-0 item-media">
                      <div className="photo-container">
                        <div className="desktop"></div>
                        <div className="tablet"></div>
                        <a className="photo-holder">
                          <img
                            src="landing-assets/vehicle/img/feature1-desktop.webp"
                            className="desktop"
                            loading="lazy"
                          />
                          <img
                            src="landing-assets/vehicle/img/feature1-tablet.webp"
                            className="tablet"
                            loading="lazy"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="group group-1">
                    <div className="item item-0 item-text title">
                      <p className="text-content">
                        Real-time smart charging synced to your energy rate.{' '}
                        <span className="text-gradient">
                          Down to the second.
                        </span>
                      </p>
                    </div>
                    <div className="item item-1 item-text body">
                      <p className="text-content">
                        Real-time rate tracking and forecasting to charge at the
                        right time.
                      </p>
                    </div>

                    <div className="item item-mobile-2 item-media mobile">
                      <div className="photo-container">
                        <div className="mobile"></div>
                        <a className="photo-holder">
                          <img
                            src="landing-assets/vehicle/img/feature1-mobile.webp"
                            className="mobile"
                            loading="lazy"
                          />
                        </a>
                      </div>
                    </div>

                    <div className="item item-2 item-list">
                      <ul className="list">
                        <li>
                          <div className="group group-0">
                            <div className="item item-0 item-icon">
                              <svg
                                width="28"
                                height="28"
                                viewBox="0 0 28 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_576_1492)">
                                  <path
                                    d="M21.0001 9.33341H19.8334V7.00008C19.8334 3.78008 17.2201 1.16675 14.0001 1.16675C10.7801 1.16675 8.16675 3.78008 8.16675 7.00008V9.33341H7.00008C5.71675 9.33341 4.66675 10.3834 4.66675 11.6667V23.3334C4.66675 24.6167 5.71675 25.6667 7.00008 25.6667H21.0001C22.2834 25.6667 23.3334 24.6167 23.3334 23.3334V11.6667C23.3334 10.3834 22.2834 9.33341 21.0001 9.33341ZM14.0001 19.8334C12.7167 19.8334 11.6667 18.7834 11.6667 17.5001C11.6667 16.2167 12.7167 15.1667 14.0001 15.1667C15.2834 15.1667 16.3334 16.2167 16.3334 17.5001C16.3334 18.7834 15.2834 19.8334 14.0001 19.8334ZM17.6167 9.33341H10.3834V7.00008C10.3834 5.00508 12.0051 3.38341 14.0001 3.38341C15.9951 3.38341 17.6167 5.00508 17.6167 7.00008V9.33341Z"
                                    fill="#3484FC"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_576_1492">
                                    <rect width="28" height="28" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            <div className="item item-1 item-text">
                              <p className="text-content">
                                Connect your car securely with end-to-end
                                encryption
                              </p>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="group group-0">
                            <div className="item item-0 item-icon">
                              <svg
                                width="28"
                                height="28"
                                viewBox="0 0 28 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_576_1496)">
                                  <path
                                    d="M7.05842 9.39175C3.87342 12.5767 3.87342 17.7334 7.03509 20.9184C8.75009 16.9517 11.8068 13.6384 15.6218 11.6667C12.3901 14.3967 10.1268 18.2117 9.33342 22.5401C12.3668 23.9751 16.1001 23.4501 18.6084 20.9417C22.6684 16.8817 23.3334 4.66675 23.3334 4.66675C23.3334 4.66675 11.1184 5.33175 7.05842 9.39175Z"
                                    fill="#00BF58"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_576_1496">
                                    <rect width="28" height="28" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            <div className="item item-1 item-text">
                              <p className="text-content">
                                Charge during windows of lower CO₂ emissions
                              </p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </section>
              <section className="section feature feature2">
                <div className="section-content">
                  <div className="group group-0 not-mobile">
                    <div className="item item-0 item-media">
                      <div className="photo-container">
                        <div className="desktop"></div>
                        <div className="tablet"></div>
                        <a className="photo-holder">
                          <img
                            src="landing-assets/vehicle/img/feature2-desktop.webp"
                            className="desktop"
                            loading="lazy"
                          />
                          <img
                            src="landing-assets/vehicle/img/feature2-tablet.webp"
                            className="tablet"
                            loading="lazy"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="group group-1">
                    <div className="item item-0 item-text title">
                      <p className="text-content">
                        <span className="text-gradient">
                          Customizable advanced scheduling
                        </span>{' '}
                        to fit your lifestyle.
                      </p>
                    </div>
                    <div className="item item-1 item-text body">
                      <p className="text-content">
                        Set custom Ready By times for each day of the week.
                      </p>
                    </div>

                    <div className="item item-mobile-2 item-media mobile">
                      <div className="photo-container">
                        <div className="mobile"></div>
                        <a className="photo-holder">
                          <img
                            src="landing-assets/vehicle/img/feature2-mobile.webp"
                            className="mobile"
                            loading="lazy"
                          />
                        </a>
                      </div>
                    </div>

                    <div className="item item-2 item-list">
                      <ul className="list">
                        <li>
                          <div className="group group-0">
                            <div className="item item-0 item-icon">
                              <svg
                                width="28"
                                height="28"
                                viewBox="0 0 28 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M23.625 18C23.625 19.6569 22.2819 21 20.625 21L4.75 21C3.09315 21 1.75 19.6569 1.75 18V10C1.75 8.34315 3.09315 7 4.75 7H20.625C22.2819 7 23.625 8.34328 23.625 10.0001V10.5V11.4406V16.625V17.5V18ZM24.5 16.625H24.5328C25.9644 16.625 27.125 15.4644 27.125 14.0328C27.125 12.6012 25.9644 11.4406 24.5328 11.4406H24.5V16.625ZM7.09835 12.6656C6.69871 12.6656 6.54613 13.1871 6.88273 13.4025L12.7719 17.1716C13.0381 17.342 13.3875 17.1508 13.3875 16.8347V15.1156H17.2268C17.6264 15.1156 17.779 14.5941 17.4424 14.3787L11.5531 10.6096C11.2869 10.4392 10.9375 10.6304 10.9375 10.9465V12.6656L7.09835 12.6656Z"
                                  fill="#871BF2"
                                />
                              </svg>
                            </div>
                            <div className="item item-1 item-text">
                              <p className="text-content">
                                Optiwatt maximizes your battery life by saving
                                the last bit of charging to pre-condition your
                                car for departure.
                              </p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </section>
              <section className="section feature feature3">
                <div className="section-content">
                  <div className="group group-0">
                    <div className="item item-0 item-media">
                      <div className="photo-container">
                        <div className="desktop"></div>
                        <div className="tablet"></div>
                        <div className="mobile"></div>
                        <a className="photo-holder">
                          <img
                            src="landing-assets/vehicle/img/feature3-desktop.webp"
                            className="desktop"
                            loading="lazy"
                          />
                          <img
                            src="landing-assets/vehicle/img/feature3-tablet.webp"
                            className="tablet"
                            loading="lazy"
                          />
                          <img
                            src="landing-assets/vehicle/img/feature3-mobile.webp"
                            className="mobile"
                            loading="lazy"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="group group-1">
                    <div className="item item-0 item-text title">
                      <p className="text-content">
                        Savings,
                        <br />{' '}
                        <span className="text-gradient">beyond your EV...</span>
                      </p>
                    </div>
                    <div className="item item-1 item-text body">
                      <p className="text-content">
                        Reduce costs further by tracking your home meter and
                        connecting your smart thermostat
                      </p>
                    </div>
                    <div className="item item-2 item-button has-link button-style-alternate">
                      <a href="/home">
                        <button className="button">
                          <span className="share-1">Learn about</span> Optiwatt
                          Home™
                          <svg
                            width="8"
                            height="10"
                            viewBox="0 0 8 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.6001 1L6.4001 5L1.6001 9"
                              stroke="#871BF2"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </section>
              <section className="section more-features">
                <div className="section-content">
                  <div className="group group-0">
                    <div className="item item-0 item-text subtitle">
                      <p className="text-content">More Features</p>
                    </div>
                    <div className="item item-1 item-text title">
                      <p className="text-content">So much more to love</p>
                    </div>
                    <div className="item item-2 item-list buttons">
                      <ul className="list">
                        <li>
                          <div className="group group-0">
                            <div className="item item-0 item-button">
                              <a>
                                <button className="button selected">
                                  Tracking
                                </button>
                              </a>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="group group-0">
                            <div className="item item-0 item-button">
                              <a>
                                <button className="button">Scheduling</button>
                              </a>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="group group-0">
                            <div className="item item-0 item-button">
                              <a>
                                <button className="button">Convenience</button>
                              </a>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="group group-1 desktop">
                    <div className="item item-0 item-list features-media">
                      <ul className="list">
                        <li>
                          <div className="group group-0">
                            <div className="item item-0 item-media">
                              <div className="photo-container">
                                <div className="desktop"></div>
                                <div className="photo-holder">
                                  <img
                                    src="landing-assets/vehicle/img/more-features-tracking.webp"
                                    className="desktop"
                                    loading="lazy"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="group group-0">
                            <div className="item item-0 item-media">
                              <div className="photo-container">
                                <div className="desktop"></div>
                                <div className="photo-holder">
                                  <img
                                    src="landing-assets/vehicle/img/more-features-scheduling.webp"
                                    className="desktop"
                                    loading="lazy"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="group group-0">
                            <div className="item item-0 item-media">
                              <div className="photo-container">
                                <div className="desktop"></div>
                                <div className="photo-holder">
                                  <img
                                    src="landing-assets/vehicle/img/more-features-convenience.webp"
                                    className="desktop"
                                    loading="lazy"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="group group-2">
                    <div className="item item-0 item-list features">
                      <ul className="list">
                        <li>
                          <div className="group group-0">
                            <div className="item item-0 item-list feature-item">
                              <ul className="list">
                                <li>
                                  <div className="group group-0">
                                    <div className="item item-0 item-text title">
                                      <p className="text-content">
                                        Cost Tracking
                                      </p>
                                    </div>
                                    <div className="item item-0 item-text body">
                                      <p className="text-content">
                                        Your electricity rates are automatically
                                        synced to Optiwatt so you can track the
                                        exact cost each time you charge
                                      </p>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="group group-0">
                                    <div className="item item-0 item-text title">
                                      <p className="text-content">
                                        Gas Savings
                                      </p>
                                    </div>
                                    <div className="item item-0 item-text body">
                                      <p className="text-content">
                                        Select your previous gas car’s model to
                                        see exactly how much you’re saving by
                                        driving electric.
                                      </p>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="group group-0">
                                    <div className="item item-0 item-text title">
                                      <p className="text-content">
                                        Advanced Rate Support
                                      </p>
                                    </div>
                                    <div className="item item-0 item-text body">
                                      <p className="text-content">
                                        Our automatic rate integration supports
                                        time-of-use, tiered, and real-time
                                        energy plans that can change throughout
                                        seasons
                                      </p>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="group group-0">
                            <div className="item item-0 item-list feature-item">
                              <ul className="list">
                                <li>
                                  <div className="group group-0">
                                    <div className="item item-0 item-text title">
                                      <p className="text-content">
                                        Smart Charging Options
                                      </p>
                                    </div>
                                    <div className="item item-0 item-text body">
                                      <p className="text-content">
                                        Don’t wait until midnight to start
                                        charging. Get more flexibility,
                                        convenience, and available charging
                                        time. You can even optimize for
                                        emissions!
                                      </p>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="group group-0">
                                    <div className="item item-0 item-text title">
                                      <p className="text-content">Trips</p>
                                    </div>
                                    <div className="item item-0 item-text body">
                                      <p className="text-content">
                                        Reduce range anxiety and preserve
                                        battery health by setting one-off
                                        upcoming trips at higher battery levels
                                      </p>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="group group-0">
                                    <div className="item item-0 item-text title">
                                      <p className="text-content">
                                        Flexible Ready By times
                                      </p>
                                    </div>
                                    <div className="item item-0 item-text body">
                                      <p className="text-content">
                                        Keep your schedule flexible by picking a
                                        different Ready By time for every day of
                                        the week
                                      </p>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="group group-0">
                            <div className="item item-0 item-list feature-item">
                              <ul className="list">
                                <li>
                                  <div className="group group-0">
                                    <div className="item item-0 item-text title">
                                      <p className="text-content">
                                        Battery Preconditioning
                                      </p>
                                    </div>
                                    <div className="item item-0 item-text body">
                                      <p className="text-content">
                                        Automatically precondition your battery
                                        and interior climate for your daily
                                        departures
                                      </p>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="group group-0">
                                    <div className="item item-0 item-text title">
                                      <p className="text-content">
                                        Multiple Brand Support
                                      </p>
                                    </div>
                                    <div className="item item-0 item-text body">
                                      <p className="text-content">
                                        We support 20 different EV brands so you
                                        can control all your vehicles under one
                                        account
                                      </p>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="group group-0">
                                    <div className="item item-0 item-text title">
                                      <p className="text-content">
                                        Emergency Preparedness
                                      </p>
                                    </div>
                                    <div className="item item-0 item-text body">
                                      <p className="text-content">
                                        Be alerted and have your battery
                                        automatically topped off prior to
                                        potential grid blackouts
                                      </p>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div className="decor decor-1">
              <div className="decor-wrapper">
                <svg
                  width="1512"
                  height="3159"
                  viewBox="0 0 1512 3159"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M372.5 787C311.327 95.5792 895 -219.5 1512.5 168V3159H1.50012L0.5 2620C265.5 2929.5 1384 2942.5 1249 1892C1154.28 1154.9 427 1403 372.5 787Z"
                    fill="#F3F6FF"
                  />
                </svg>
              </div>
            </div>
            <section className="section how-it-works">
              <div className="section-content">
                <div className="group group-0">
                  <div className="item item-0 item-list ">
                    <ul className="list photos">
                      <li>
                        <div className="bg-helper-container">
                          <div
                            className="bg-helper"
                            style={{
                              backgroundImage:
                                "url('landing-assets/vehicle/img/hyundai-car.webp')",
                            }}
                          ></div>
                        </div>
                      </li>
                      <li>
                        <div className="bg-helper-container">
                          <div
                            className="bg-helper"
                            style={{
                              backgroundImage:
                                "url('landing-assets/vehicle/img/modern-house.webp')",
                            }}
                          ></div>
                        </div>
                      </li>
                      <li>
                        <div className="bg-helper-container">
                          <div
                            className="bg-helper"
                            style={{
                              backgroundImage:
                                "url('landing-assets/vehicle/img/relax-phone.webp')",
                            }}
                          ></div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="item item-1 item-list steps">
                    <ul className="list">
                      <li>
                        <div className="group group-0">
                          <div className="item item-0 item-text subtitle">
                            <p className="text-content">STEP 1</p>
                          </div>
                          <div className="item item-1 item-text title">
                            <p className="text-content">Connect your EV</p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="group group-0">
                          <div className="item item-0 item-text subtitle">
                            <p className="text-content">STEP 2</p>
                          </div>
                          <div className="item item-1 item-text title">
                            <p className="text-content">Connect your utility</p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="group group-0">
                          <div className="item item-0 item-text subtitle">
                            <p className="text-content">STEP 3</p>
                          </div>
                          <div className="item item-1 item-text title">
                            <p className="text-content">
                              Start saving & tracking
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="group group-1">
                  <div className="item item-0 item-list notes">
                    <ul className="list">
                      <li id="hiw1">
                        <div className="item item-0 item-text title note">
                          <p className="text-content">
                            Connect to as many EVs as you want safely with
                            end-to-end encryption
                          </p>
                        </div>
                      </li>
                      <li id="hiw2">
                        <div className="item item-0 item-text title note">
                          <p className="text-content">
                            Sign in to your utility provider account to connect
                            to Optiwatt
                          </p>
                        </div>
                      </li>
                      <li id="hiw3">
                        <div className="item item-0 item-text title note">
                          <p className="text-content">
                            Sit back and watch Optiwatt save you money every
                            month
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
            <section className="section ready-to-start">
              <div className="section-content">
                <div className="group group-0">
                  <div className="item item-0 item-text title">
                    <p className="text-content">Ready to get started?</p>
                  </div>
                  <div className="item item-1 item-text body">
                    <p className="text-content">Optiwatt is free. Forever.</p>
                  </div>
                </div>
                <div className="group group-1">
                  <div className="item item-0 item-text top">
                    <p className="text-content">4.8 Star rating</p>
                  </div>
                  <div className="item item-1 item-svg">
                    <svg
                      width="204"
                      height="36"
                      viewBox="0 0 204 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="36" height="36" rx="6" fill="#FFC83C" />
                      <g filter="url(#filter0_d_597_1400)">
                        <path
                          d="M16.5734 8.39057C17.0224 7.00861 18.9776 7.00861 19.4266 8.39058L20.8064 12.6373C21.0072 13.2553 21.5832 13.6738 22.233 13.6738H26.6983C28.1514 13.6738 28.7555 15.5332 27.5799 16.3873L23.9675 19.0119C23.4417 19.3939 23.2218 20.0709 23.4226 20.689L24.8024 24.9357C25.2514 26.3176 23.6697 27.4668 22.4941 26.6127L18.8817 23.9881C18.3559 23.6061 17.6441 23.6061 17.1183 23.9881L13.5059 26.6127C12.3303 27.4668 10.7486 26.3176 11.1976 24.9357L12.5774 20.6889C12.7782 20.0709 12.5583 19.3939 12.0325 19.0119L8.42005 16.3873C7.24448 15.5332 7.84865 13.6738 9.30173 13.6738H13.767C14.4168 13.6738 14.9928 13.2553 15.1936 12.6373L16.5734 8.39057Z"
                          fill="white"
                        />
                      </g>
                      <rect
                        x="42"
                        width="36"
                        height="36"
                        rx="6"
                        fill="#FFC83C"
                      />
                      <g filter="url(#filter1_d_597_1400)">
                        <path
                          d="M58.5734 8.39057C59.0224 7.00861 60.9776 7.00861 61.4266 8.39058L62.8064 12.6373C63.0072 13.2553 63.5832 13.6738 64.233 13.6738H68.6983C70.1514 13.6738 70.7555 15.5332 69.5799 16.3873L65.9675 19.0119C65.4417 19.3939 65.2218 20.0709 65.4226 20.689L66.8024 24.9357C67.2514 26.3176 65.6697 27.4668 64.4941 26.6127L60.8817 23.9881C60.3559 23.6061 59.6441 23.6061 59.1183 23.9881L55.5059 26.6127C54.3303 27.4668 52.7486 26.3176 53.1976 24.9357L54.5774 20.6889C54.7782 20.0709 54.5583 19.3939 54.0325 19.0119L50.4201 16.3873C49.2445 15.5332 49.8486 13.6738 51.3017 13.6738H55.767C56.4168 13.6738 56.9928 13.2553 57.1936 12.6373L58.5734 8.39057Z"
                          fill="white"
                        />
                      </g>
                      <rect
                        x="84"
                        width="36"
                        height="36"
                        rx="6"
                        fill="#FFC83C"
                      />
                      <g filter="url(#filter2_d_597_1400)">
                        <path
                          d="M100.573 8.39057C101.022 7.00861 102.978 7.00861 103.427 8.39058L104.806 12.6373C105.007 13.2553 105.583 13.6738 106.233 13.6738H110.698C112.151 13.6738 112.756 15.5332 111.58 16.3873L107.967 19.0119C107.442 19.3939 107.222 20.0709 107.423 20.689L108.802 24.9357C109.251 26.3176 107.67 27.4668 106.494 26.6127L102.882 23.9881C102.356 23.6061 101.644 23.6061 101.118 23.9881L97.5059 26.6127C96.3303 27.4668 94.7486 26.3176 95.1976 24.9357L96.5774 20.6889C96.7782 20.0709 96.5583 19.3939 96.0325 19.0119L92.4201 16.3873C91.2445 15.5332 91.8486 13.6738 93.3017 13.6738H97.767C98.4168 13.6738 98.9928 13.2553 99.1936 12.6373L100.573 8.39057Z"
                          fill="white"
                        />
                      </g>
                      <rect
                        x="126"
                        width="36"
                        height="36"
                        rx="6"
                        fill="#FFC83C"
                      />
                      <g filter="url(#filter3_d_597_1400)">
                        <path
                          d="M142.573 8.39057C143.022 7.00861 144.978 7.00861 145.427 8.39058L146.806 12.6373C147.007 13.2553 147.583 13.6738 148.233 13.6738H152.698C154.151 13.6738 154.756 15.5332 153.58 16.3873L149.967 19.0119C149.442 19.3939 149.222 20.0709 149.423 20.689L150.802 24.9357C151.251 26.3176 149.67 27.4668 148.494 26.6127L144.882 23.9881C144.356 23.6061 143.644 23.6061 143.118 23.9881L139.506 26.6127C138.33 27.4668 136.749 26.3176 137.198 24.9357L138.577 20.6889C138.778 20.0709 138.558 19.3939 138.033 19.0119L134.42 16.3873C133.244 15.5332 133.849 13.6738 135.302 13.6738H139.767C140.417 13.6738 140.993 13.2553 141.194 12.6373L142.573 8.39057Z"
                          fill="white"
                        />
                      </g>
                      <rect
                        x="168"
                        width="36"
                        height="36"
                        rx="6"
                        fill="#FFC83C"
                      />
                      <g filter="url(#filter4_d_597_1400)">
                        <path
                          d="M184.573 8.39057C185.022 7.00861 186.978 7.00861 187.427 8.39058L188.806 12.6373C189.007 13.2553 189.583 13.6738 190.233 13.6738H194.698C196.151 13.6738 196.756 15.5332 195.58 16.3873L191.967 19.0119C191.442 19.3939 191.222 20.0709 191.423 20.689L192.802 24.9357C193.251 26.3176 191.67 27.4668 190.494 26.6127L186.882 23.9881C186.356 23.6061 185.644 23.6061 185.118 23.9881L181.506 26.6127C180.33 27.4668 178.749 26.3176 179.198 24.9357L180.577 20.6889C180.778 20.0709 180.558 19.3939 180.033 19.0119L176.42 16.3873C175.244 15.5332 175.849 13.6738 177.302 13.6738H181.767C182.417 13.6738 182.993 13.2553 183.194 12.6373L184.573 8.39057Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_597_1400"
                          x="2.79883"
                          y="6.35413"
                          width="30.4023"
                          height="29.5519"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="2.5" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.779167 0 0 0 0 0.545455 0 0 0 0 0.0941493 0 0 0 0.38 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_597_1400"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_597_1400"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter1_d_597_1400"
                          x="44.7988"
                          y="6.35413"
                          width="30.4023"
                          height="29.5519"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="2.5" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.779167 0 0 0 0 0.545455 0 0 0 0 0.0941493 0 0 0 0.38 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_597_1400"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_597_1400"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter2_d_597_1400"
                          x="86.7988"
                          y="6.35413"
                          width="30.4023"
                          height="29.5519"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="2.5" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.779167 0 0 0 0 0.545455 0 0 0 0 0.0941493 0 0 0 0.38 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_597_1400"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_597_1400"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter3_d_597_1400"
                          x="128.799"
                          y="6.35413"
                          width="30.4023"
                          height="29.5519"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="2.5" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.779167 0 0 0 0 0.545455 0 0 0 0 0.0941493 0 0 0 0.38 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_597_1400"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_597_1400"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter4_d_597_1400"
                          x="170.799"
                          y="6.35413"
                          width="30.4023"
                          height="29.5519"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="2.5" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.779167 0 0 0 0 0.545455 0 0 0 0 0.0941493 0 0 0 0.38 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_597_1400"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_597_1400"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </div>
                  <div className="item item-2 item-text bottom">
                    <p className="text-content">150,000 App downloads</p>
                  </div>
                </div>
                <div className="group group-2">
                  <div className="item item-0 item-button has-link button-style-primary-white">
                    <a href={props.signUpPath}>
                      <button className="button">Sign up now</button>
                    </a>
                  </div>
                </div>
              </div>
            </section>
            <section className="section integrity">
              <div className="section-content">
                <div className="group group-0">
                  <div className="item item-0 item-text title">
                    <p className="text-content">
                      <span className="text-gradient">Free forever.</span>
                      <br />
                      No tricks.
                      <br />
                      No gimmicks.
                    </p>
                  </div>
                </div>
                <div className="group group-1">
                  <div className="item item-0 item-list cards">
                    <ul className="list">
                      <li>
                        <div className="group group-0">
                          <div className="item item-0 item-icon">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                width="32"
                                height="32"
                                rx="16"
                                fill="url(#paint0_linear_744_3495)"
                              />
                              <g clipPath="url(#clip0_744_3495)">
                                <path
                                  d="M8.76624 23.2707C9.13024 23.6347 9.71824 23.6347 10.0822 23.2707L10.4462 22.9067C10.8102 22.5427 10.8009 21.9547 10.4462 21.6L10.4369 21.5907C10.0729 21.2267 9.48491 21.2267 9.12091 21.5907L8.75691 21.9547C8.40224 22.328 8.40224 22.9067 8.76624 23.2707ZM15.9902 26.2667H15.9996C16.5129 26.2667 16.9236 25.856 16.9236 25.3427V24.4467C16.9236 23.9334 16.5129 23.5227 15.9996 23.5227H15.9902C15.4769 23.5227 15.0662 23.9334 15.0662 24.4467V25.3427C15.0662 25.856 15.4769 26.2667 15.9902 26.2667ZM7.60891 15.1134H6.65691C6.14358 15.1134 5.73291 15.524 5.73291 16.0374V16.0467C5.73291 16.56 6.14358 16.9707 6.65691 16.9707H7.59958C8.11291 16.9707 8.52358 16.56 8.52358 16.0467V16.0374C8.53291 15.524 8.12224 15.1134 7.60891 15.1134ZM18.7996 11.2027V7.64671C18.7996 7.13338 18.3796 6.71338 17.8662 6.71338H14.1329C13.6196 6.71338 13.1996 7.13338 13.1996 7.64671V11.2027C11.2956 12.304 10.1009 14.488 10.4649 16.924C10.8382 19.36 12.8542 21.3107 15.2996 21.6094C18.6969 22.02 21.5996 19.3694 21.5996 16.056C21.5996 13.9747 20.4702 12.1734 18.7996 11.2027ZM23.4662 16.0374V16.0467C23.4662 16.56 23.8769 16.9707 24.3902 16.9707H25.3329C25.8462 16.9707 26.2569 16.56 26.2569 16.0467V16.0374C26.2569 15.524 25.8462 15.1134 25.3329 15.1134H24.3902C23.8769 15.1134 23.4662 15.524 23.4662 16.0374ZM21.5436 22.916L21.9076 23.28C22.2716 23.644 22.8596 23.644 23.2236 23.28C23.5876 22.916 23.5876 22.328 23.2236 21.964L22.8596 21.6C22.4956 21.236 21.9076 21.2454 21.5529 21.6C21.1796 21.9734 21.1796 22.552 21.5436 22.916Z"
                                  fill="white"
                                />
                              </g>
                              <defs>
                                <linearGradient
                                  id="paint0_linear_744_3495"
                                  x1="26.6475"
                                  y1="5.4"
                                  x2="3.54167"
                                  y2="25.7656"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stopColor="#E346FF" />
                                  <stop offset="1" stopColor="#7826FF" />
                                </linearGradient>
                                <clipPath id="clip0_744_3495">
                                  <rect
                                    width="22.4"
                                    height="22.4"
                                    fill="white"
                                    transform="translate(4.7998 4.80005)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div className="item item-1 item-text title">
                            <p className="text-content">Electric Company</p>
                          </div>
                        </div>
                        <div className="group group-1">
                          <div className="item item-0 item-text body">
                            <p className="text-content">
                              Optiwatt helps companies purchase electricity at
                              the right time to maximize savings.
                            </p>
                          </div>
                        </div>
                        <div className="group group-2">
                          <div className="item item-media item-0">
                            <div className="photo-container">
                              <div style={{ paddingTop: '54.51327434%' }}></div>
                              <div className="photo-holder">
                                <img
                                  src="landing-assets/vehicle/img/handwriting-arrow.webp"
                                  loading="lazy"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="group group-0">
                          <div className="item item-0 item-icon">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clipPath="url(#clip0_752_1514)">
                                <circle
                                  cx="16.2"
                                  cy="15.8001"
                                  r="14.2"
                                  fill="white"
                                />
                                <path
                                  d="M15.9979 0C7.1648 0 0 7.16479 0 16.0021C0 24.8393 7.1648 32.0041 15.9979 32.0041C24.8311 32.0041 31.9959 24.8393 31.9959 16.0021C31.9959 7.16479 24.8352 0 15.9979 0ZM7.81727 13.8671L17.117 4.10892C17.8315 3.36147 19.0373 4.19151 18.5954 5.12479L12.6365 17.6663H16.3944L15.2629 20.049H10.4684C7.25152 20.049 5.59969 16.192 7.81727 13.8629V13.8671ZM24.1827 18.1329L14.883 27.8911C14.1685 28.6385 12.9627 27.8085 13.4046 26.8752L19.3635 14.3337H15.6056L16.7371 11.951H21.5316C24.7485 11.951 26.4003 15.808 24.1827 18.137V18.1329Z"
                                  fill="url(#paint0_linear_752_1514)"
                                />
                              </g>
                              <defs>
                                <linearGradient
                                  id="paint0_linear_752_1514"
                                  x1="26.644"
                                  y1="5.4007"
                                  x2="3.536"
                                  y2="25.763"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stopColor="#E346FF" />
                                  <stop offset="1" stopColor="#7826FF" />
                                </linearGradient>
                                <clipPath id="clip0_752_1514">
                                  <rect width="32" height="32" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div className="item item-1 item-text title">
                            <p className="text-content">Optiwatt</p>
                          </div>
                        </div>
                        <div className="group group-1">
                          <div className="item item-1 item-text body">
                            <p className="text-content">
                              Companies give a portion of the savings to
                              Optiwatt, allowing us to provide awesome features
                              to you.
                            </p>
                          </div>
                        </div>
                        <div className="group group-2">
                          <div className="item item-media item-0">
                            <div className="photo-container">
                              <div style={{ paddingTop: '54.51327434%' }}></div>
                              <div className="photo-holder">
                                <img
                                  src="landing-assets/vehicle/img/handwriting-arrow.webp"
                                  loading="lazy"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="group group-0">
                          <div className="item item-0 item-icon">
                            <svg
                              width="80"
                              height="81"
                              viewBox="0 0 80 81"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                y="0.990234"
                                width="80"
                                height="80"
                                rx="40"
                                fill="url(#paint0_linear_716_1471)"
                              />
                              <g clipPath="url(#clip0_716_1471)">
                                <path
                                  d="M40 38.9902C45.525 38.9902 50 34.5152 50 28.9902C50 23.4652 45.525 18.9902 40 18.9902C34.475 18.9902 30 23.4652 30 28.9902C30 34.5152 34.475 38.9902 40 38.9902ZM40 43.9902C33.325 43.9902 20 47.3402 20 53.9902V56.4902C20 57.8652 21.125 58.9902 22.5 58.9902H57.5C58.875 58.9902 60 57.8652 60 56.4902V53.9902C60 47.3402 46.675 43.9902 40 43.9902Z"
                                  fill="white"
                                />
                              </g>
                              <defs>
                                <linearGradient
                                  id="paint0_linear_716_1471"
                                  x1="66.6187"
                                  y1="14.4902"
                                  x2="8.85418"
                                  y2="65.4043"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stopColor="#E346FF" />
                                  <stop offset="1" stopColor="#7826FF" />
                                </linearGradient>
                                <clipPath id="clip0_716_1471">
                                  <rect
                                    width="60"
                                    height="60"
                                    fill="white"
                                    transform="translate(10 8.99023)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div className="item item-1 item-text title">
                            <p className="text-content">You</p>
                          </div>
                        </div>
                        <div className="group group-1">
                          <div className="item item-1 item-text body">
                            <p className="text-content">
                              Because you charge in off-peak hours, electric
                              companies bill you less, resulting in huge
                              savings.
                            </p>
                          </div>
                        </div>
                        <div className="group group-2">
                          <div className="item item-media item-0">
                            <div className="photo-container">
                              <div style={{ paddingTop: '54.51327434%' }}></div>
                              <div className="photo-holder">
                                <img
                                  src="landing-assets/vehicle/img/handwriting-arrow.webp"
                                  loading="lazy"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
            <section className="section faq">
              <div className="section-content">
                <div className="group group-0">
                  <div className="item item-0 item-text subtitle">
                    <p className="text-content">FAQ</p>
                  </div>
                  <div className="item item-1 item-text title">
                    <p className="text-content">We’re here to help!</p>
                  </div>
                  <div className="item item-2 item-list questions">
                    <ul className="list">
                      <li>
                        <div className="group group-0">
                          <div className="item item-0 item-text title">
                            <p className="text-content">
                              Is Optiwatt secure? Is my password safe?
                            </p>
                          </div>
                          <div className="item item-1 item-svg">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="16"
                                cy="16"
                                r="15"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                              />
                              <path
                                className="plus"
                                d="M16 9.5V22.5"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                              <path
                                d="M9.5 16.0005L22.5 16.0005"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="group group-1">
                          <div className="item item-1 item-text body">
                            <p className="text-content">
                              Optiwatt never stores your credentials on our
                              servers and your data is 100% safe. When you
                              connect Optiwatt to your EV account using your
                              login credentials, we receive an authorization
                              token that can be used to communicate directly
                              with your vehicle. Optiwatt then stores an
                              encrypted version of that authentication token and
                              discards any sensitive data.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="group group-0">
                          <div className="item item-0 item-text title">
                            <p className="text-content">
                              Does Optiwatt keep my car awake?
                            </p>
                          </div>
                          <div className="item item-1 item-svg">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="16"
                                cy="16"
                                r="15"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                              />
                              <path
                                className="plus"
                                d="M16 9.5V22.5"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                              <path
                                d="M9.5 16.0005L22.5 16.0005"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="group group-1">
                          <div className="item item-1 item-text body">
                            <p className="text-content">
                              No. Optiwatt will stop requesting data whenever
                              your car is ready to naturally fall asleep (i.e
                              sitting in your driveway). This ensures your car
                              sleeps during its normal cycle, to avoid causing
                              any additional phantom drain.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="group group-0">
                          <div className="item item-0 item-text title">
                            <p className="text-content">
                              How does the charge schedule work?
                            </p>
                          </div>
                          <div className="item item-1 item-svg">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="16"
                                cy="16"
                                r="15"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                              />
                              <path
                                className="plus"
                                d="M16 9.5V22.5"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                              <path
                                d="M9.5 16.0005L22.5 16.0005"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="group group-1">
                          <div className="item item-1 item-text body">
                            <p className="text-content">
                              Optiwatt uses your utility plan and exact
                              electricity rates in order to determine the
                              cheapest possible times to charge. Users who want
                              more control can set their target Ready By time
                              and battery level and Optiwatt will determine the
                              best hours to charge to ensure these targets are
                              met.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="group group-0">
                          <div className="item item-0 item-text title">
                            <p className="text-content">
                              What is Optiwatt's Preconditioning?
                            </p>
                          </div>
                          <div className="item item-1 item-svg">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="16"
                                cy="16"
                                r="15"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                              />
                              <path
                                className="plus"
                                d="M16 9.5V22.5"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                              <path
                                d="M9.5 16.0005L22.5 16.0005"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="group group-1">
                          <div className="item item-1 item-text body">
                            <p className="text-content">
                              If you enable Preconditioning for your charge
                              schedule in Optiwatt, Optiwatt will automatically
                              warm the battery pack for your departure to reduce
                              some of the effects of cold weather on your EV.❄️
                              <br />
                              <br />
                              When the battery has been warmed up, your vehicle
                              will have better regenerative braking, more power
                              available from the motors, and longer range.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="group group-0">
                          <div className="item item-0 item-text title">
                            <p className="text-content">
                              How does Optiwatt make money?
                            </p>
                          </div>
                          <div className="item item-1 item-svg">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="16"
                                cy="16"
                                r="15"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                              />
                              <path
                                className="plus"
                                d="M16 9.5V22.5"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                              <path
                                d="M9.5 16.0005L22.5 16.0005"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="group group-1">
                          <div className="item item-1 item-text body">
                            <p className="text-content">
                              Our goal is to work with utility companies and
                              reduce peak-load demand by scheduling charges
                              during off-peak hours. This will save utilities
                              money by preventing additional "peaker" power
                              plants from needing to be fired up.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="group group-0">
                          <div className="item item-0 item-text title">
                            <p className="text-content">
                              What vehicle makes and models does Optiwatt
                              support?
                            </p>
                          </div>
                          <div className="item item-1 item-svg">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="16"
                                cy="16"
                                r="15"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                              />
                              <path
                                className="plus"
                                d="M16 9.5V22.5"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                              <path
                                d="M9.5 16.0005L22.5 16.0005"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="group group-1">
                          <div className="item item-1 item-text body">
                            <p className="text-content">
                              Optiwatt currently supports all Tesla models, the
                              BMW i3, i3 BEV, i3s, 330e, 530e, 745e xDrive, 740e
                              xDrive, i8, X3 xDrive30e, X5 xDrive40e, and X5
                              xDrive45e, the Chevrolet Bolt EV, Spark EV, and
                              Volt, the Ford Focus Electric, Mach E, C-MAX
                              Energi Plug-In Hybrid, Escape PHEV, and Fusion
                              Energi Plug-In Hybrid, the Jaguar I-Pace and
                              I-PaceEV400, the VW e-Golf and ID.4, the Audi A7
                              PHEV, A8 PHEV, Q5 PHEV, e-tron, Q4 e-tron, e-tron
                              GT, the Cadillac CT6 plug-in and ELR, the Chrysler
                              Pacifica Hybrid, the Hyundai Ioniq Plug-In Hybrid,
                              Kona Electric, Sonata Plug-In Hybrid, and Ioniq
                              Electric, the Jeep Wrangler 4xe, the Land Rover
                              Range Rover PHEV and Ranger Rover Sport PHEV, the
                              Lincoln Aviator PHEV and Corsair PHEV, the Nissan
                              Leaf, the Volvo S60 PHEV, S90 PHEV, V60 PHEV, XC60
                              PHEV, and XC90 PHEV. We add new makes and models
                              on a regular basis, so stay tuned for updates!
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="group group-0">
                          <div className="item item-0 item-text title">
                            <p className="text-content">
                              Is this different from my vehicle manufacturer’s
                              app?
                            </p>
                          </div>
                          <div className="item item-1 item-svg">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="16"
                                cy="16"
                                r="15"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                              />
                              <path
                                className="plus"
                                d="M16 9.5V22.5"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                              <path
                                d="M9.5 16.0005L22.5 16.0005"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="group group-1">
                          <div className="item item-1 item-text body">
                            <p className="text-content">
                              Yes, Optiwatt's charging schedule provides more
                              control and flexibility. In addition to postponing
                              charging until the cheapest rates begin, it also
                              stops charging as soon as the more expensive rates
                              return. Optiwatt’s charging schedule dynamically
                              adjusts on days where you drive more than normal,
                              to ensure you still have the range you need for
                              the following day.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="group group-0">
                          <div className="item item-0 item-text title">
                            <p className="text-content">
                              Do I have to use Optiwatt’s scheduler?
                            </p>
                          </div>
                          <div className="item item-1 item-svg">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="16"
                                cy="16"
                                r="15"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                              />
                              <path
                                className="plus"
                                d="M16 9.5V22.5"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                              <path
                                d="M9.5 16.0005L22.5 16.0005"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="group group-1">
                          <div className="item item-1 item-text body">
                            <p className="text-content">
                              No, all scheduler settings can be disabled upon
                              sign-up or log-in if desired.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="group group-0">
                          <div className="item item-0 item-text title">
                            <p className="text-content">
                              Does this work outside of the USA?
                            </p>
                          </div>
                          <div className="item item-1 item-svg">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="16"
                                cy="16"
                                r="15"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                              />
                              <path
                                className="plus"
                                d="M16 9.5V22.5"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                              <path
                                d="M9.5 16.0005L22.5 16.0005"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="group group-1">
                          <div className="item item-1 item-text body">
                            <p className="text-content">
                              Yes, we support all countries and currencies.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="group group-0">
                          <div className="item item-0 item-text title">
                            <p className="text-content">
                              How does this save earth?
                            </p>
                          </div>
                          <div className="item item-1 item-svg">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="16"
                                cy="16"
                                r="15"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                              />
                              <path
                                className="plus"
                                d="M16 9.5V22.5"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                              <path
                                d="M9.5 16.0005L22.5 16.0005"
                                stroke="#C9D1E7"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="group group-1">
                          <div className="item item-1 item-text body">
                            <p className="text-content">
                              Utility companies are forced to turn on
                              environmentally unfriendly fossil fuel based power
                              plants during times of peak-demand. Optiwatt will
                              charge your car during off-peak hours when your
                              rates are lowest, therefore shifting peak load and
                              preventing these coal generators from ever being
                              needed.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
            <section className="section form">
              <div className="section-content">
                <div className="group group-0">
                  <div className="item item-0 item-text title">
                    <p className="text-content">
                      Don’t see your question? Ask us here:
                    </p>
                  </div>
                  <div className="item item-1 item-form">
                    <form id="faq-form">
                      <div className="group group-0">
                        <div className="item item-0 item-input">
                          <div className="input-wrapper">
                            <input
                              type="input"
                              id="faq-question"
                              placeholder="Type your question..."
                              required
                              minLength={3}
                            />
                          </div>
                        </div>
                        <div className="item item-1 item-input">
                          <div className="input-wrapper">
                            <input
                              type="email"
                              id="faq-email"
                              placeholder="Enter your email"
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="group group-1">
                        <div className="item item-0 item-button button-style-primary">
                          <button
                            className="button"
                            id="faq-submit"
                            type="submit"
                          >
                            Submit
                          </button>
                        </div>
                        <div className="item item-1 item-text label">
                          <p className="text-content">
                            We usually will reply in 48 hours
                          </p>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <footer className="footer">
            <div className="section-content">
              <div className="group group-0">
                <div className="item item-0 item-media">
                  <div className="photo-container">
                    <div style={{ paddingTop: '18.5%' }}></div>
                    <a className="photo-holder">
                      <img
                        src="landing-assets/vehicle/img/logoLight.webp"
                        loading="lazy"
                      />
                    </a>
                  </div>
                </div>
                <div className="item item-1 item-text">
                  <p className="text-content">
                    Copyrights © {new Date().getFullYear()}. <br />
                    All rights reserved by Optiwatt
                  </p>
                </div>
              </div>
              <div className="group group-1">
                <div className="item item-0 item-text title">
                  <p className="text-content">About</p>
                </div>
                <div className="item item-1 item-list links">
                  <ul className="list">
                    <li>
                      <a
                        href="https://optiwatt.applytojob.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className="group group-0">
                          <div className="item item-0 item-text link">
                            <p className="text-content">Careers</p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="/privacy">
                        <div className="group group-0">
                          <div className="item item-0 item-text link">
                            <p className="text-content">Privacy Policy</p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="/tos">
                        <div className="group group-0">
                          <div className="item item-0 item-text link">
                            <p className="text-content">Terms of Service</p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="/faq">
                        <div className="group group-0">
                          <div className="item item-0 item-text link">
                            <p className="text-content">FAQ</p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="/partners">
                        <div className="group group-0">
                          <div className="item item-0 item-text link">
                            <p className="text-content">For Partners</p>
                          </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="group group-2">
                <div className="item item-0 item-text title">
                  <p className="text-content">Contact</p>
                </div>
                <div className="item item-1 item-list links">
                  <ul className="list">
                    <li>
                      <a>
                        <div className="group group-0">
                          <div className="item item-0 item-svg">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clipPath="url(#clip0_752_1557)">
                                <path
                                  d="M12 2C8.13 2 5 5.13 5 9C5 13.17 9.42 18.92 11.24 21.11C11.64 21.59 12.37 21.59 12.77 21.11C14.58 18.92 19 13.17 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z"
                                  fill="#871BF2"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_752_1557">
                                  <rect width="24" height="24" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div className="item item-1 item-text link">
                            <p className="text-content">
                              {optiwattConsts.contact.location}
                            </p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        href={`mailto:${optiwattConsts.contact.email}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className="group group-0">
                          <div className="item item-0 item-svg">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clipPath="url(#clip0_752_1560)">
                                <path
                                  d="M12.7201 2.03007C6.63007 1.60007 1.60007 6.63007 2.03007 12.7201C2.39007 18.0101 7.01007 22.0001 12.3101 22.0001H16.0001C16.5501 22.0001 17.0001 21.5501 17.0001 21.0001C17.0001 20.4501 16.5501 20.0001 16.0001 20.0001H12.3301C8.60007 20.0001 5.18007 17.5801 4.25007 13.9701C2.76007 8.17007 8.16007 2.76007 13.9601 4.26007C17.5801 5.18007 20.0001 8.60007 20.0001 12.3301V13.4301C20.0001 14.2201 19.2901 15.0001 18.5001 15.0001C17.7101 15.0001 17.0001 14.2201 17.0001 13.4301V12.1801C17.0001 9.67007 15.2201 7.41007 12.7401 7.06007C9.34007 6.57007 6.47007 9.51007 7.08007 12.9301C7.42007 14.8401 8.91007 16.4201 10.8001 16.8701C12.6401 17.3001 14.3901 16.7101 15.5401 15.5401C16.4301 16.7601 18.2101 17.4001 19.8401 16.7501C21.1801 16.2201 22.0001 14.8501 22.0001 13.4101V12.3201C22.0001 7.01007 18.0101 2.39007 12.7201 2.03007ZM12.0001 15.0001C10.3401 15.0001 9.00007 13.6601 9.00007 12.0001C9.00007 10.3401 10.3401 9.00007 12.0001 9.00007C13.6601 9.00007 15.0001 10.3401 15.0001 12.0001C15.0001 13.6601 13.6601 15.0001 12.0001 15.0001Z"
                                  fill="#871BF2"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_752_1560">
                                  <rect width="24" height="24" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div className="item item-1 item-text link">
                            <p className="text-content">
                              {optiwattConsts.contact.email}
                            </p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        href={optiwattConsts.contact.website}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className="group group-0">
                          <div className="item item-0 item-svg">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clipPath="url(#clip0_752_1563)">
                                <path
                                  d="M6.18 19.9999C7.38398 19.9999 8.36 19.0239 8.36 17.8199C8.36 16.6159 7.38398 15.6399 6.18 15.6399C4.97602 15.6399 4 16.6159 4 17.8199C4 19.0239 4.97602 19.9999 6.18 19.9999Z"
                                  fill="#871BF2"
                                />
                                <path
                                  d="M5.59 10.2301C4.75 10.0901 4 10.7801 4 11.6301C4 12.3401 4.53 12.9101 5.23 13.0301C8.15 13.5401 10.45 15.8501 10.97 18.7701C11.09 19.4701 11.66 20.0001 12.37 20.0001C13.22 20.0001 13.91 19.2501 13.78 18.4101C13.1 14.2101 9.79 10.9001 5.59 10.2301V10.2301ZM5.56 4.52009C4.73 4.43009 4 5.10009 4 5.93009C4 6.66009 4.55 7.26009 5.27 7.33009C11.28 7.93009 16.06 12.7101 16.66 18.7201C16.73 19.4501 17.33 20.0001 18.06 20.0001C18.9 20.0001 19.56 19.2701 19.48 18.4401C18.75 11.1001 12.91 5.25009 5.56 4.52009V4.52009Z"
                                  fill="#871BF2"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_752_1563">
                                  <rect width="24" height="24" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div className="item item-1 item-text link">
                            <p className="text-content">
                              {optiwattConsts.contact.website}
                            </p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href={`tel:${optiwattConsts.contact.phoneNumber}`}>
                        <div className="group group-0">
                          <div
                            className="item item-0 item-svg"
                            style={{
                              width: '24px',
                              height: '24px',
                              padding: '2px',
                            }}
                          >
                            <img
                              src="img/feathericons/primary/phone.webp"
                              alt="phone"
                              style={{ width: '100%' }}
                            />
                          </div>
                          <div className="item item-1 item-text link">
                            <p className="text-content">
                              {optiwattConsts.contact.phoneNumber}
                            </p>
                          </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="group group-3">
                <div className="item item-0 item-text title">
                  <p className="text-content">Social</p>
                </div>
                <div className="item item-1 item-list links">
                  <ul className="list">
                    <li>
                      <a
                        href={optiwattConsts.social.facebook}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className="group group-0">
                          <div className="item item-0 item-svg">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clipPath="url(#clip0_719_2115)">
                                <path
                                  d="M22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 16.84 5.44 20.87 10 21.8V15H8V12H10V9.5C10 7.57 11.57 6 13.5 6H16V9H14C13.45 9 13 9.45 13 10V12H16V15H13V21.95C18.05 21.45 22 17.19 22 12Z"
                                  fill="#337FFF"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_719_2115">
                                  <rect width="24" height="24" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div className="item item-1 item-text link">
                            <p className="text-content">Facebook</p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        href={optiwattConsts.social.twitter}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className="group group-0">
                          <div className="item item-0 item-svg">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.8803 6.25002C20.2951 6.50187 19.6799 6.67725 19.0498 6.77182C19.3444 6.72132 19.7778 6.1911 19.9503 5.97649C20.2125 5.65276 20.4122 5.28321 20.5395 4.88659C20.5395 4.85713 20.5689 4.81505 20.5395 4.79401C20.5246 4.78591 20.508 4.78166 20.4911 4.78166C20.4742 4.78166 20.4575 4.78591 20.4427 4.79401C19.7585 5.1645 19.0304 5.44727 18.2755 5.63563C18.2492 5.64367 18.2212 5.64439 18.1945 5.63772C18.1678 5.63105 18.1435 5.61723 18.124 5.59776C18.0653 5.52779 18.002 5.46172 17.9347 5.39998C17.6268 5.12411 17.2774 4.89833 16.8995 4.73089C16.3893 4.52157 15.8381 4.43091 15.2878 4.46578C14.7537 4.4995 14.2323 4.64274 13.756 4.88659C13.287 5.14367 12.8747 5.49293 12.5441 5.91337C12.1963 6.34611 11.9452 6.84831 11.8077 7.3862C11.6943 7.89785 11.6814 8.42665 11.7698 8.9432C11.7698 9.03157 11.7698 9.0442 11.694 9.03157C8.69366 8.58972 6.23191 7.52507 4.22044 5.24007C4.13207 5.13907 4.08578 5.13907 4.01424 5.24007C3.13895 6.56983 3.56397 8.67389 4.65808 9.71329C4.80536 9.85216 4.95686 9.98682 5.11676 10.1131C4.61512 10.0774 4.12573 9.9415 3.67759 9.71329C3.59343 9.65858 3.54714 9.68804 3.54293 9.78903C3.531 9.92905 3.531 10.0698 3.54293 10.2098C3.63074 10.8809 3.89518 11.5165 4.30923 12.0518C4.72327 12.5871 5.27206 13.0029 5.89947 13.2565C6.05242 13.322 6.21179 13.3714 6.37499 13.4038C5.91059 13.4952 5.4343 13.5094 4.96527 13.4459C4.86428 13.4248 4.8264 13.4795 4.86428 13.5763C5.48287 15.2596 6.82526 15.773 7.80995 16.0591C7.94461 16.0802 8.07927 16.0802 8.23076 16.1138C8.23076 16.1138 8.23076 16.1138 8.20552 16.1391C7.91516 16.6693 6.74109 17.027 6.20246 17.2121C5.2193 17.5653 4.17108 17.7003 3.13054 17.6077C2.96642 17.5825 2.92855 17.5867 2.88647 17.6077C2.84439 17.6287 2.88647 17.675 2.93276 17.7171C3.14316 17.856 3.35357 17.978 3.57239 18.0958C4.22382 18.4512 4.91252 18.7334 5.62595 18.9375C9.32066 19.9558 13.4783 19.2068 16.2514 16.4505C18.4312 14.2875 19.1971 11.304 19.1971 8.3162C19.1971 8.20258 19.336 8.13525 19.4159 8.07633C19.9674 7.64664 20.4536 7.13918 20.8593 6.56983C20.9296 6.48496 20.9656 6.3769 20.9603 6.26685V6.26685C20.9603 6.20373 20.9603 6.21635 20.8803 6.25002Z"
                                fill="#33CCFF"
                              />
                            </svg>
                          </div>
                          <div className="item item-1 item-text link">
                            <p className="text-content">Twitter</p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        href={optiwattConsts.social.youtube}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className="group group-0">
                          <div className="item item-0 item-svg">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M21.7731 7.04025C21.5417 6.17028 20.8571 5.48397 19.9862 5.24876C18.4113 4.82666 12.0928 4.82666 12.0928 4.82666C12.0928 4.82666 5.77745 4.82666 4.19941 5.24876C3.33166 5.48075 2.64709 6.16706 2.41248 7.04025C1.99146 8.61909 1.99146 11.9153 1.99146 11.9153C1.99146 11.9153 1.99146 15.2115 2.41248 16.7904C2.64388 17.6603 3.32844 18.3467 4.19941 18.5819C5.77745 19.004 12.0928 19.004 12.0928 19.004C12.0928 19.004 18.4113 19.004 19.9862 18.5819C20.8539 18.3499 21.5385 17.6636 21.7731 16.7904C22.1941 15.2115 22.1941 11.9153 22.1941 11.9153C22.1941 11.9153 22.1941 8.61909 21.7731 7.04025Z"
                                fill="#FF3000"
                              />
                              <path
                                d="M10.0745 14.9538L15.3228 11.9153L10.0745 8.87686V14.9538Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                          <div className="item item-1 item-text link">
                            <p className="text-content">YouTube</p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        href={optiwattConsts.social.instagram}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className="group group-0">
                          <div className="item item-0 item-svg">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.68867 11.9152C8.68867 10.1337 10.1333 8.68915 11.9159 8.68915C13.6985 8.68915 15.1439 10.1337 15.1439 11.9152C15.1439 13.6967 13.6985 15.1413 11.9159 15.1413C10.1333 15.1413 8.68867 13.6967 8.68867 11.9152ZM6.94367 11.9152C6.94367 14.6597 9.16973 16.8845 11.9159 16.8845C14.6621 16.8845 16.8881 14.6597 16.8881 11.9152C16.8881 9.1707 14.6621 6.94597 11.9159 6.94597C9.16973 6.94597 6.94367 9.1707 6.94367 11.9152ZM15.923 6.74894C15.9229 6.97862 15.9909 7.20317 16.1185 7.3942C16.2461 7.58522 16.4276 7.73414 16.6398 7.82212C16.8521 7.9101 17.0858 7.93319 17.3112 7.88847C17.5366 7.84375 17.7437 7.73323 17.9063 7.57089C18.0688 7.40855 18.1796 7.20167 18.2245 6.97642C18.2694 6.75117 18.2465 6.51766 18.1587 6.30543C18.0708 6.0932 17.9219 5.91177 17.7309 5.78409C17.5399 5.65641 17.3152 5.58821 17.0854 5.58812H17.085C16.7769 5.58826 16.4815 5.71059 16.2636 5.92824C16.0458 6.1459 15.9232 6.44107 15.923 6.74894ZM8.00387 19.7924C7.05979 19.7494 6.54666 19.5923 6.20565 19.4595C5.75356 19.2836 5.431 19.0741 5.09185 18.7356C4.75271 18.3971 4.54277 18.0751 4.36755 17.6233C4.23461 17.2826 4.07736 16.7696 4.03444 15.8261C3.9875 14.8061 3.97813 14.4996 3.97813 11.9153C3.97813 9.33095 3.98827 9.02538 4.03444 8.00445C4.07744 7.06094 4.23585 6.54897 4.36755 6.20732C4.54355 5.7555 4.75317 5.43312 5.09185 5.09418C5.43053 4.75524 5.75279 4.54543 6.20565 4.37031C6.5465 4.23746 7.05979 4.0803 8.00387 4.03741C9.02456 3.99049 9.33117 3.98112 11.9159 3.98112C14.5006 3.98112 14.8075 3.99126 15.8291 4.03741C16.7732 4.08037 17.2854 4.2387 17.6273 4.37031C18.0794 4.54543 18.4019 4.7557 18.7411 5.09418C19.0802 5.43266 19.2894 5.7555 19.4654 6.20732C19.5983 6.54796 19.7556 7.06094 19.7985 8.00445C19.8454 9.02538 19.8548 9.33095 19.8548 11.9153C19.8548 14.4996 19.8454 14.8052 19.7985 15.8261C19.7555 16.7696 19.5975 17.2825 19.4654 17.6233C19.2894 18.0751 19.0798 18.3975 18.7411 18.7356C18.4024 19.0738 18.0794 19.2836 17.6273 19.4595C17.2864 19.5923 16.7732 19.7495 15.8291 19.7924C14.8084 19.8393 14.5018 19.8487 11.9159 19.8487C9.33001 19.8487 9.02425 19.8393 8.00387 19.7924ZM7.92369 2.2964C6.89285 2.34332 6.18846 2.50667 5.5733 2.7459C4.93622 2.99294 4.39691 3.32437 3.85798 3.86213C3.31905 4.39988 2.98827 4.93973 2.74107 5.57643C2.5017 6.1916 2.33825 6.89519 2.29131 7.92541C2.24359 8.95725 2.23267 9.28714 2.23267 11.9152C2.23267 14.5433 2.24359 14.8732 2.29131 15.905C2.33825 16.9353 2.5017 17.6388 2.74107 18.254C2.98827 18.8903 3.31912 19.4308 3.85798 19.9683C4.39683 20.5058 4.93622 20.8368 5.5733 21.0845C6.18962 21.3238 6.89285 21.4871 7.92369 21.534C8.9567 21.5809 9.28624 21.5926 11.9159 21.5926C14.5455 21.5926 14.8756 21.5817 15.9081 21.534C16.939 21.4871 17.6429 21.3238 18.2585 21.0845C18.8952 20.8368 19.4349 20.5061 19.9738 19.9683C20.5127 19.4305 20.8428 18.8903 21.0907 18.254C21.3301 17.6388 21.4943 16.9352 21.5405 15.905C21.5874 14.8724 21.5983 14.5433 21.5983 11.9152C21.5983 9.28714 21.5874 8.95725 21.5405 7.92541C21.4935 6.89511 21.3301 6.19121 21.0907 5.57643C20.8428 4.94012 20.5119 4.40073 19.9738 3.86213C19.4357 3.32352 18.8952 2.99294 18.2593 2.7459C17.6429 2.50667 16.9389 2.34254 15.9089 2.2964C14.8764 2.24948 14.5463 2.23779 11.9167 2.23779C9.28701 2.23779 8.9567 2.24871 7.92369 2.2964Z"
                                fill="url(#paint0_radial_719_2129)"
                              />
                              <path
                                d="M8.68867 11.9152C8.68867 10.1337 10.1333 8.68915 11.9159 8.68915C13.6985 8.68915 15.1439 10.1337 15.1439 11.9152C15.1439 13.6967 13.6985 15.1413 11.9159 15.1413C10.1333 15.1413 8.68867 13.6967 8.68867 11.9152ZM6.94367 11.9152C6.94367 14.6597 9.16973 16.8845 11.9159 16.8845C14.6621 16.8845 16.8881 14.6597 16.8881 11.9152C16.8881 9.1707 14.6621 6.94597 11.9159 6.94597C9.16973 6.94597 6.94367 9.1707 6.94367 11.9152ZM15.923 6.74894C15.9229 6.97862 15.9909 7.20317 16.1185 7.3942C16.2461 7.58522 16.4276 7.73414 16.6398 7.82212C16.8521 7.9101 17.0858 7.93319 17.3112 7.88847C17.5366 7.84375 17.7437 7.73323 17.9063 7.57089C18.0688 7.40855 18.1796 7.20167 18.2245 6.97642C18.2694 6.75117 18.2465 6.51766 18.1587 6.30543C18.0708 6.0932 17.9219 5.91177 17.7309 5.78409C17.5399 5.65641 17.3152 5.58821 17.0854 5.58812H17.085C16.7769 5.58826 16.4815 5.71059 16.2636 5.92824C16.0458 6.1459 15.9232 6.44107 15.923 6.74894ZM8.00387 19.7924C7.05979 19.7494 6.54666 19.5923 6.20565 19.4595C5.75356 19.2836 5.431 19.0741 5.09185 18.7356C4.75271 18.3971 4.54277 18.0751 4.36755 17.6233C4.23461 17.2826 4.07736 16.7696 4.03444 15.8261C3.9875 14.8061 3.97813 14.4996 3.97813 11.9153C3.97813 9.33095 3.98827 9.02538 4.03444 8.00445C4.07744 7.06094 4.23585 6.54897 4.36755 6.20732C4.54355 5.7555 4.75317 5.43312 5.09185 5.09418C5.43053 4.75524 5.75279 4.54543 6.20565 4.37031C6.5465 4.23746 7.05979 4.0803 8.00387 4.03741C9.02456 3.99049 9.33117 3.98112 11.9159 3.98112C14.5006 3.98112 14.8075 3.99126 15.8291 4.03741C16.7732 4.08037 17.2854 4.2387 17.6273 4.37031C18.0794 4.54543 18.4019 4.7557 18.7411 5.09418C19.0802 5.43266 19.2894 5.7555 19.4654 6.20732C19.5983 6.54796 19.7556 7.06094 19.7985 8.00445C19.8454 9.02538 19.8548 9.33095 19.8548 11.9153C19.8548 14.4996 19.8454 14.8052 19.7985 15.8261C19.7555 16.7696 19.5975 17.2825 19.4654 17.6233C19.2894 18.0751 19.0798 18.3975 18.7411 18.7356C18.4024 19.0738 18.0794 19.2836 17.6273 19.4595C17.2864 19.5923 16.7732 19.7495 15.8291 19.7924C14.8084 19.8393 14.5018 19.8487 11.9159 19.8487C9.33001 19.8487 9.02425 19.8393 8.00387 19.7924ZM7.92369 2.2964C6.89285 2.34332 6.18846 2.50667 5.5733 2.7459C4.93622 2.99294 4.39691 3.32437 3.85798 3.86213C3.31905 4.39988 2.98827 4.93973 2.74107 5.57643C2.5017 6.1916 2.33825 6.89519 2.29131 7.92541C2.24359 8.95725 2.23267 9.28714 2.23267 11.9152C2.23267 14.5433 2.24359 14.8732 2.29131 15.905C2.33825 16.9353 2.5017 17.6388 2.74107 18.254C2.98827 18.8903 3.31912 19.4308 3.85798 19.9683C4.39683 20.5058 4.93622 20.8368 5.5733 21.0845C6.18962 21.3238 6.89285 21.4871 7.92369 21.534C8.9567 21.5809 9.28624 21.5926 11.9159 21.5926C14.5455 21.5926 14.8756 21.5817 15.9081 21.534C16.939 21.4871 17.6429 21.3238 18.2585 21.0845C18.8952 20.8368 19.4349 20.5061 19.9738 19.9683C20.5127 19.4305 20.8428 18.8903 21.0907 18.254C21.3301 17.6388 21.4943 16.9352 21.5405 15.905C21.5874 14.8724 21.5983 14.5433 21.5983 11.9152C21.5983 9.28714 21.5874 8.95725 21.5405 7.92541C21.4935 6.89511 21.3301 6.19121 21.0907 5.57643C20.8428 4.94012 20.5119 4.40073 19.9738 3.86213C19.4357 3.32352 18.8952 2.99294 18.2593 2.7459C17.6429 2.50667 16.9389 2.34254 15.9089 2.2964C14.8764 2.24948 14.5463 2.23779 11.9167 2.23779C9.28701 2.23779 8.9567 2.24871 7.92369 2.2964Z"
                                fill="url(#paint1_radial_719_2129)"
                              />
                              <defs>
                                <radialGradient
                                  id="paint0_radial_719_2129"
                                  cx="0"
                                  cy="0"
                                  r="1"
                                  gradientUnits="userSpaceOnUse"
                                  gradientTransform="translate(4.80561 21.6841) scale(25.2813 25.2661)"
                                >
                                  <stop offset="0.09" stopColor="#FA8F21" />
                                  <stop offset="0.78" stopColor="#D82D7E" />
                                </radialGradient>
                                <radialGradient
                                  id="paint1_radial_719_2129"
                                  cx="0"
                                  cy="0"
                                  r="1"
                                  gradientUnits="userSpaceOnUse"
                                  gradientTransform="translate(13.9776 22.5512) scale(19.9251 19.9132)"
                                >
                                  <stop
                                    offset="0.64"
                                    stopColor="#8C3AAA"
                                    stopOpacity="0"
                                  />
                                  <stop offset="1" stopColor="#8C3AAA" />
                                </radialGradient>
                              </defs>
                            </svg>
                          </div>
                          <div className="item item-1 item-text">
                            <p className="text-content">Instagram</p>
                          </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>

      <div className="modal" id="form-submitted">
        <div className="modal-overlay"></div>
        <div className="modal-content">
          <div className="group group-0">
            <div className="item item-0 item-svg">
              <svg
                width="120"
                height="120"
                viewBox="0 0 120 120"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="120" height="120" fill="white" />
                <path
                  d="M86 64.2881H83.0533L74.3867 72.859H82.6633L90.3333 81.4299H29.6667L37.38 72.859H46.2633L37.5967 64.2881H34L21 77.1444V94.2862C21 99.0002 24.8567 102.857 29.6233 102.857H90.3333C95.1 102.857 99 99.0431 99 94.2862V77.1444L86 64.2881ZM81.6667 42.6466L60.2167 63.8596L44.8767 48.6891L66.3267 27.4761L81.6667 42.6466ZM63.2933 18.391L35.69 45.6893C34 47.3606 34 50.0604 35.69 51.7318L57.14 72.9447C58.83 74.616 61.56 74.616 63.25 72.9447L90.81 45.6893C92.5 44.018 92.5 41.3181 90.81 39.6468L69.36 18.4339C67.7133 16.7197 64.9833 16.7197 63.2933 18.391Z"
                  fill="url(#paint0_linear_841_1633)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_841_1633"
                    x1="85.9532"
                    y1="31.6071"
                    x2="25.0559"
                    y2="80.4516"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#E346FF" />
                    <stop offset="1" stopColor="#7826FF" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div className="item item-1 item-text title">
              <p className="text-content">Question Submitted</p>
            </div>
            <div className="item item-2 item-text body">
              <p className="text-content">
                Thank you for sending your question. Our team will be in touch
                with you soon!
              </p>
            </div>
            <div className="item item-3 item-button has-link button-style-alternate">
              <a>
                <button className="button">Close</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default function VehicleLanding(props: Props) {
  console.log(props)
  return (
    <StylesProvider injectFirst>
      <MuiThemeProvider theme={maTheme}>
        <ThemeProvider theme={maTheme}>
          <VehicleLandingComponent {...props} />
        </ThemeProvider>
      </MuiThemeProvider>
    </StylesProvider>
  )
}
